import React, {useEffect} from 'react'
import {FormInputComponent} from "../../../components/form/Form";
import {useSupplierServiceOfferingFormItem} from "../providers/SupplierServiceOfferingFormItemProvider";
import {Button, Divider, InputNumber, Tag} from "antd";
import FlipMove from "react-flip-move";
import SearchBrandsInput from "../../../components/form/SearchBrandsInput";
import {SearchTagsExpertise} from "../../talent-application/components/KeyClientsForm";
import {DeleteOutlined, PictureOutlined, PlusOutlined} from "@ant-design/icons";
import InfoTooltip from "../../../components/InfoTooltip";
import {useNavigate} from "react-router-dom";
import ServiceCategorySelect from "./ServiceCategorySelect";
import ServiceOfferingsSubStepRelatedWork from "./ServiceOfferingsSubStepRelatedWork";
import {useAuth} from "../../../providers/AuthProvider";
import ServiceOffering from "../../../models/ServiceOffering";

const MAX_TAGS_COUNT = 12;


// Main ServiceNameStep component that decides which provider to use
const ServiceNameStep = () => {
    const {
        profileItem,
        profileIndex,
        onModelChange,
        model,
        refresh,
        isEditing
    } = useSupplierServiceOfferingFormItem();
    const navigate = useNavigate();

    const offeringIndex = parseInt(profileIndex);
    const offering = (profileItem.service_offerings || [])[offeringIndex];

    useEffect(() => {
        if (!offering) {
            // navigate('../../');
            return;
        }

        // Check if service_tags exist

        if (profileItem?.name?.length > 0) {
            // Has service tags, redirect to first wizard step (overview)
            console.log('redirect', profileItem.name);
            navigate(`services`, { replace: true });
        }
        // If no service tags, stay on this route and show ServiceCategoryStep
    }, [offering, navigate]);

    if (!profileItem) {
        return <div>Loading...</div>;
    }

    return (
        <div className="flex flex-col space-y-6">
            {/* Name */}
            <div className="field-section flex-row">
                <div className="field px-3.5 basis-6/12">
                    <FormInputComponent
                        fieldName="name"
                        value={profileItem.name}
                        type="text"
                        label="Service Name"
                        placeholder="e.g., Digital Marketing Strategy"
                        maxLength={255}
                        required={true}
                    />
                </div>

            </div>
        </div>
    )
};

// Main ServiceCategoryStep component that decides which provider to use
const ServiceCategoryStep = () => {
    const {
        profileItem,
        profileIndex,
        onModelChange,
        model,
        refresh,
        isEditing
    } = useSupplierServiceOfferingFormItem();
    const navigate = useNavigate();

    const offeringIndex = parseInt(profileIndex);
    const offering = (profileItem.service_offerings || [])[offeringIndex];

    useEffect(() => {
        if (!offering) {
            // navigate('../../');
            return;
        }

        // Check if service_tags exist
        const hasServiceTags = offering.service_tags && offering.service_tags.length > 0;

        if (hasServiceTags) {
            // Has service tags, redirect to first wizard step (overview)
            console.log('redirect', hasServiceTags);
            navigate(`overview`, { replace: true });
        }
        // If no service tags, stay on this route and show ServiceCategoryStep
    }, [offering, navigate]);

    if (!profileItem) {
        return <div>Loading...</div>;
    }

    return (
        <ServiceCategorySelect/>
    );
};

// Overview Step Component (without Tags Section)
const OverviewStep = () => {
    const context = useSupplierServiceOfferingFormItem();

    if (!context) {
        return <div>Loading...</div>;
    }

    const {
        profileItem,
        profileIndex,
        onModelChange,
        refresh,
        isEditing
    } = context;

    return (
        <div className="flex flex-col space-y-6">
            {/* Name */}
            {/*<div className="field-section flex-row">*/}
            {/*    <div className="field px-3.5 basis-6/12">*/}
            {/*        <FormInputComponent*/}
            {/*            fieldName="name"*/}
            {/*            value={profileItem.name}*/}
            {/*            type="text"*/}
            {/*            label="Service Name"*/}
            {/*            placeholder="e.g., Digital Marketing Strategy"*/}
            {/*            maxLength={255}*/}
            {/*            required={true}*/}
            {/*        />*/}
            {/*    </div>*/}

            {/*</div>*/}
            {/* Tagline */}
            <div className="field-section flex-row">
                <div className="field px-3.5 basis-9/12">
                    <FormInputComponent
                        fieldName="tag_line"
                        value={profileItem.tag_line}
                        type="text"
                        label="Tag Line"
                        placeholder="Brief catchy description"
                        maxLength={1000}
                        minLength={30}
                        required={true}
                    />
                </div>
            </div>

            {/* Image */}
            <div className="field-section flex-row">
                <div className="field px-3.5 basis-8/12">
                    <FormInputComponent
                        fieldName="image_path"
                        value={profileItem.image_path}
                        label="Service Image"
                        type="pixie"
                        ratio="16:9"
                        circular={false}
                        width={400}
                        required={true}
                    />
                </div>
            </div>

            {/* Fee Information */}
            <div className="field-section flex-row items-center">
                <div className="field px-3.5 basis-6/12 [&>.form-group]:flex [&>.form-group]:flex-col">
                    <FormInputComponent
                        fieldName="fee_type"
                        value={profileItem.fee_type}
                        type="select"
                        label="Fee Type"
                        required={false}
                        options={TB.reduce(laravel.service_fee_types, (result, label, value) => {
                            result.push({label, value})
                            return result;
                        }, [])}
                    />
                </div>
                {ServiceOffering.labelForFeeType(profileItem.fee_type) && (
                    <div className="field px-3.5 basis-6/12">
                        <FormInputComponent
                            fieldName="fee_amount"
                            value={profileItem.fee_amount}
                            label={ServiceOffering.labelForFeeType(profileItem.fee_type)}
                            type='antd-input'
                            className="[&>.ant-input-number]:border-transparent [&>.ant-input-number]:rounded-none"
                            required={true}
                        >
                            <InputNumber
                                disabled={!isEditing}
                                min={0}
                                max={10000000}
                                formatter={(value) => {
                                    return `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }}
                                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                addonAfter={laravel.service_fee_types?.[profileItem.fee_type]?.includes('Rate') ? '/ hr' : undefined}
                                placeholder="Enter amount"
                                style={{width: '100%'}}
                            />
                        </FormInputComponent>
                    </div>
                )}
            </div>

            {/* Summary */}
            <div className="field-section flex-row">
                <div className="field px-3.5 basis-12/12">
                    <FormInputComponent
                        fieldName="summary"
                        value={profileItem.summary}
                        type="editor"
                        label="Service Summary"
                        placeholder="Describe what this service offering includes..."
                        maxLength={10000}
                        minLength={50}
                        enableScroll={true}
                        validation={{
                            rules: {
                                maxLength: 10000,
                            },
                            errors: {
                                maxLength: TB.trans('validation.max.string', {
                                    'attribute': 'service summary',
                                    'max': 10000
                                }),
                                minCharLength: TB.trans('validation.min.string', {
                                    'attribute': 'service summary',
                                    'min': 50
                                })
                            }
                        }}
                        required={true}
                    />
                </div>
            </div>

            {/* Process */}
            <div className="field-section flex-row">
                <div className="field px-3.5 basis-12/12">
                    <FormInputComponent
                        fieldName="process"
                        value={profileItem.process}
                        type="editor"
                        label="Process Description"
                        placeholder="Explain your process for delivering this service..."
                        maxLength={10000}
                        required={false}
                    />
                </div>
            </div>
        </div>
    );
};

// Search Tags Step Component (extracted Tags Section)
const SearchTagsStep = () => {
    const context = useSupplierServiceOfferingFormItem();

    if (!context) {
        return <div>Loading...</div>;
    }

    const {
        profileItem,
        profileIndex,
        onModelChange,
        refresh,
        isEditing
    } = context;

    let {
        disciplines = [],
        skills = [],
        industries = [],
        ...props
    } = profileItem;

    const allTags = TB.concat(
        TB.map(disciplines || [], item => ({...item, type: 'disciplines', value: `discipline-${item.id}`})),
        TB.map(skills || [], item => ({...item, type: 'skills', value: `skill-${item.id}`})),
        TB.map(industries || [], item => ({...item, type: 'industries', value: `industry-${item.id}`}))
    );

    let sections = [
        {items: disciplines, type: 'disciplines', label: 'Roles'},
        {items: skills, type: 'skills', label: 'Skills'},
        {items: industries, type: 'industries', label: 'Industries'},
    ]

    return (
        <div className="flex flex-col space-y-6">
            {/* Tags Section */}
            {TB.map(sections, section => {
                return (
                    <div key={section.label} className="space-y-4">
                        <h4 className="text-lg font-semibold">{section.label}</h4>

                        {/* Display existing tags */}
                        {section.items?.length > 0 && (
                            <div className="field px-3.5">
                                <label className="col-form-label flex flex-row items-center gap-7">
                                    <span>Selected {section.label}</span>
                                    <span className={TB.mapClass("ml-auto text-xxs italic", {
                                        "opacity-7": section.items?.length < MAX_TAGS_COUNT,
                                        "text-danger font-semibold opacity-1": section.items?.length === MAX_TAGS_COUNT,
                                    })}>
                                        Max ({section.items?.length} / {MAX_TAGS_COUNT})
                                    </span>
                                </label>
                                <div className="discipline-skills-container">
                                    <FlipMove typeName={null} maintainContainerHeight={true}>
                                        {TB.map(section.items || [], (item, tagIndex) => {
                                            const colorMap = {
                                                industries: 'default',
                                                skills: 'geekblue',
                                                disciplines: 'purple'
                                            };

                                            return (
                                                <Tag
                                                    key={item.value}
                                                    color={colorMap[item.type]}
                                                    closable={isEditing}
                                                    onClose={() => {
                                                        const currentTags = profileItem[item.type] || [];
                                                        const filteredTags = TB.filter(currentTags, option => parseInt(option?.id) !== parseInt(item.id));
                                                        onModelChange({
                                                            ...profileItem,
                                                            [item.type]: filteredTags
                                                        });
                                                    }}
                                                    className="mr-3 my-1.5"
                                                >
                                                    {item.name}
                                                </Tag>
                                            );
                                        })}
                                    </FlipMove>
                                </div>
                            </div>
                        )}

                        {/* Tag search */}
                        <div className="field px-3.5">
                            <SearchTagsExpertise
                                isDisabled={!isEditing}
                                isEditable={isEditing}
                                value={section.items}
                                placeholder={`Search tags for ${TB.toLower(section.label)}`}
                                maxCount={MAX_TAGS_COUNT}
                                filterByType={section.type}
                                onChange={params => {
                                    console.log('params', params);

                                    onModelChange({
                                        ...profileItem,
                                        [section.type]:params[section.type] || []
                                    });
                                }}
                            />
                        </div>


                    </div>
                )
            })}

            {/* Hidden form fields for tags */}
            <FormInputComponent
                type="hidden"
                style={{display: 'none'}}
                fieldName="industries"
                value={profileItem.industries}
            />
            <FormInputComponent
                type="hidden"
                style={{display: 'none'}}
                fieldName="skills"
                value={profileItem.skills}
            />
            <FormInputComponent
                type="hidden"
                style={{display: 'none'}}
                fieldName="disciplines"
                value={profileItem.disciplines}
            />
        </div>
    );
};

// Deliverables Step Component
const DeliverablesStep = () => {
    const context = useSupplierServiceOfferingFormItem();

    if (!context) {
        return <div>Loading...</div>;
    }

    const {
        profileItem,
        profileIndex,
        onModelChange,
        refresh,
        isEditing
    } = context;

    let {
        deliverables = []
    } = profileItem;

    const addDeliverable = () => {
        const updatedDeliverables = [...(deliverables || [])];
        updatedDeliverables.push({ name: '', description: '' });
        onModelChange({
            ...profileItem,
            deliverables: updatedDeliverables
        });
    };

    const updateDeliverable = (deliverableIndex, field, value) => {
        const updatedDeliverables = [...(deliverables || [])];
        if (!updatedDeliverables[deliverableIndex]) return;

        updatedDeliverables[deliverableIndex] = {
            ...updatedDeliverables[deliverableIndex],
            [field]: value
        };
        onModelChange({
            ...profileItem,
            deliverables: updatedDeliverables
        });
    };

    const removeDeliverable = (deliverableIndex) => {
        const updatedDeliverables = [...(deliverables || [])];
        updatedDeliverables.splice(deliverableIndex, 1);
        onModelChange({
            ...profileItem,
            deliverables: updatedDeliverables
        });
    };

    return (
        <div className="flex flex-col space-y-6">
            {/* Deliverables Section */}
            <div className="space-y-4">
                <h4 className="text-lg font-semibold">Deliverables</h4>
                {TB.map(deliverables || [], (deliverable, deliverableIndex) => (
                    <div key={deliverableIndex} className="border p-4 rounded bg-gray-50">
                        <div className="flex justify-between items-center mb-3">
                            <span className="font-medium">Deliverable {deliverableIndex + 1}</span>
                            {isEditing && (
                                <Button
                                    type="button"
                                    danger
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    onClick={() => removeDeliverable(deliverableIndex)}
                                />
                            )}
                        </div>
                        <div className="field-section flex-row">
                            <div className="field px-3.5 basis-6/12">
                                <FormInputComponent
                                    fieldName={`deliverables[${deliverableIndex}].name`}
                                    value={deliverable.name}
                                    type="text"
                                    label="Name"
                                    placeholder="e.g., Marketing Strategy Document"
                                    maxLength={255}
                                    required={false}
                                    onChange={(value) => updateDeliverable(deliverableIndex, 'name', value)}
                                />
                            </div>
                            <div className="field px-3.5 basis-6/12">
                                <FormInputComponent
                                    fieldName={`deliverables[${deliverableIndex}].description`}
                                    value={deliverable.description}
                                    type="textarea"
                                    label="Description"
                                    placeholder="Describe what this deliverable includes..."
                                    maxLength={10000}
                                    required={false}
                                    onChange={(value) => updateDeliverable(deliverableIndex, 'description', value)}
                                />
                            </div>
                        </div>
                    </div>
                ))}
                {isEditing && (
                    <Button
                        type="button"
                        icon={<PlusOutlined />}
                        onClick={addDeliverable}
                    >
                        Add Deliverable
                    </Button>
                )}

                {/* Hidden form field for deliverables */}
                <FormInputComponent
                    type="hidden"
                    style={{display: 'none'}}
                    fieldName="deliverables"
                    value={profileItem.deliverables}
                />
            </div>
        </div>
    );
};

// FAQs Step Component
const FAQsStep = () => {
    const context = useSupplierServiceOfferingFormItem();

    if (!context) {
        return <div>Loading...</div>;
    }

    const {
        profileItem,
        profileIndex,
        onModelChange,
        refresh,
        isEditing
    } = context;

    let {
        faqs = []
    } = profileItem;

    const addFaq = () => {
        const updatedFaqs = [...(faqs || [])];
        updatedFaqs.push({ question: '', answer: '' });
        onModelChange({
            ...profileItem,
            faqs: updatedFaqs
        });
    };

    const updateFaq = (faqIndex, field, value) => {
        const updatedFaqs = [...(faqs || [])];
        if (!updatedFaqs[faqIndex]) return;

        updatedFaqs[faqIndex] = {
            ...updatedFaqs[faqIndex],
            [field]: value
        };
        onModelChange({
            ...profileItem,
            faqs: updatedFaqs
        });
    };

    const removeFaq = (faqIndex) => {
        const updatedFaqs = [...(faqs || [])];
        updatedFaqs.splice(faqIndex, 1);
        onModelChange({
            ...profileItem,
            faqs: updatedFaqs
        });
    };

    return (
        <div className="flex flex-col space-y-6">
            {/* FAQs Section */}
            <div className="space-y-4">
                <h4 className="text-lg font-semibold">Frequently Asked Questions</h4>
                {TB.map(faqs || [], (faq, faqIndex) => (
                    <div key={faqIndex} className="border p-4 rounded bg-gray-50">
                        <div className="flex justify-between items-center mb-3">
                            <span className="font-medium">FAQ {faqIndex + 1}</span>
                            {isEditing && (
                                <Button
                                    type="button"
                                    danger
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    onClick={() => removeFaq(faqIndex)}
                                />
                            )}
                        </div>
                        <div className="field-section flex-col space-y-3">
                            <div className="field px-3.5">
                                <FormInputComponent
                                    fieldName={`faqs[${faqIndex}].question`}
                                    value={faq.question}
                                    type="text"
                                    label="Question"
                                    placeholder="What question do clients frequently ask?"
                                    maxLength={255}
                                    required={false}
                                    onChange={(value) => updateFaq(faqIndex, 'question', value)}
                                />
                            </div>
                            <div className="field px-3.5">
                                <FormInputComponent
                                    fieldName={`faqs[${faqIndex}].answer`}
                                    value={faq.answer}
                                    type="textarea"
                                    label="Answer"
                                    placeholder="Provide a helpful answer..."
                                    maxLength={10000}
                                    required={false}
                                    onChange={(value) => updateFaq(faqIndex, 'answer', value)}
                                />
                            </div>
                        </div>
                    </div>
                ))}
                {isEditing && (
                    <Button
                        type="button"
                        icon={<PlusOutlined />}
                        onClick={addFaq}
                    >
                        Add FAQ
                    </Button>
                )}

                {/* Hidden form field for faqs */}
                <FormInputComponent
                    type="hidden"
                    style={{display: 'none'}}
                    fieldName="faqs"
                    value={profileItem.faqs}
                />
            </div>
        </div>
    );
};

// Related Projects (Brands) Step Component
const RelatedProjectsStep = () => {
    const context = useSupplierServiceOfferingFormItem();
    const {auth} = useAuth();
    if (!context) {
        return <div>Loading...</div>;
    }

    return <ServiceOfferingsSubStepRelatedWork/>
};

export {
    ServiceNameStep,
    ServiceCategoryStep,
    OverviewStep,
    SearchTagsStep,
    DeliverablesStep,
    FAQsStep,
    RelatedProjectsStep
};